/**
 * Create an XML tag
 *
 * If `content` is not specified, the method generates an unpaired tag. Otherwise, paired tag is generated.
 */

export function makeTag(
  tagName: string,
  attributes: { [k: string]: string | number } = {},
  content?: string,
): string {
  const attrStr = Object.entries(attributes).reduce(
    (str, [attr, val]) =>
      Number.isFinite(val as number)
        ? `${str} ${attr}="${val}"`
        : `${str} ${attr}=${JSON.stringify(val)}`,
    '',
  );
  return `<${tagName}${attrStr}${content ? `>${content}</${tagName}>` : '/>'}`;
}
